<main>
  <router-outlet *ngIf="authorized"></router-outlet>
</main>
